function dataURItoBlob(dataURI: string, fileName: string) {
  // base on https://stackoverflow.com/questions/6850276/how-to-convert-dataurl-to-file-object-in-javascript
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  const byteString = atob(dataURI.split(',')[1]);

  // separate out the mime component
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to an ArrayBuffer
  const ab = new ArrayBuffer(byteString.length);

  // create a view into the buffer
  const ia = new Uint8Array(ab);

  // set the bytes of the buffer to the correct values
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // write the ArrayBuffer to a blob, and you're done
  const blob = new Blob([ab], { type: mimeString }) as File;

  return Object.assign(blob, {
    lastModifiedDate: new Date(),
    name: fileName,
  }) as File;
}

const getImageDimensions = (img: HTMLImageElement): [number, number] => {
  const [MAX_WIDTH, MAX_HEIGHT] = [1200, 800];
  let width = img.width;
  let height = img.height;
  if (width > height) {
    if (width > MAX_WIDTH) {
      height *= MAX_WIDTH / width;
      width = MAX_WIDTH;
    }
  } else {
    if (height > MAX_HEIGHT) {
      width *= MAX_HEIGHT / height;
      height = MAX_HEIGHT;
    }
  }
  return [width, height];
};

export default function scaleImage(file: File): Promise<File> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = window.URL.createObjectURL(file);
    img.onload = () => {
      const [width, height] = getImageDimensions(img);
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.drawImage(img, 0, 0, width, height);
      }
      resolve(dataURItoBlob(canvas.toDataURL('image/jpeg', 0.6), file.name));
    };
    img.onerror = (e) => reject(e);
  });
}
